import DashboardLoading from "../../components/Dashboard/DashboardLoading";
import EventFirstDashboard from "../../components/Dashboard/EventFirstDashboard";
import Header from "../../components/Header/Header";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/storeHook";

const Home = () => {
  const { user, initialized } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const hasLeagueInvite = new URLSearchParams(location.search).has("team");

  return (
    <>
      {!initialized ? (
        <>
        <Header />
        <main className="min-h-[calc(100vh-64px)] bg-[#1c1d21] px-4 py-6 text-slate-100 md:px-8">
          <div className="mx-auto grid w-full max-w-5xl gap-6">
            <DashboardLoading />
          </div>
        </main>
        </>
      ) : user ? (
        <EventFirstDashboard user={user} />
      ) : (
        <>
        <Header />
        <main className="min-h-[calc(100vh-64px)] bg-[#1c1d21] px-4 py-8 text-slate-100 md:px-8">
          <section className="mx-auto grid w-full max-w-5xl gap-6 rounded-lg border border-white/10 bg-white/[0.03] p-6 shadow-2xl shadow-black/20 md:p-8">
            <div className="max-w-2xl">
              <span className="text-xs font-bold uppercase tracking-[0.18em] text-accent-color-2">
                Sidewinder
              </span>
              <h1 className="m-0 mt-2 text-3xl text-white md:text-4xl">
                {hasLeagueInvite
                  ? "Join your Sidewinder league team"
                  : "Register for Sidewinder volleyball"}
              </h1>
				<p className="m-0 mt-3 text-sm leading-6 text-slate-300">
                {hasLeagueInvite
                  ? "Sign in or create an account to accept this team invite."
                  : "Sign in to manage athletes, register for club tryouts and clinics, track payment status, and view upcoming Sidewinder events."}
              </p>
              {hasLeagueInvite ? (
                <Link
                  to={`/auth${location.search}`}
                  className="mt-4 inline-flex min-h-[46px] items-center justify-center rounded-md border border-accent-color-1 bg-accent-color-1 px-4 py-3 font-bold text-white transition hover:border-[#c75a48] hover:bg-[#c75a48]"
                >
                  Sign in to join team
                </Link>
              ) : null}
            </div>

            <div className="grid gap-3 md:grid-cols-3">
              <div className="rounded-md border border-white/10 bg-black/20 p-4">
                <h2 className="m-0 text-lg text-white">Youth Athletes</h2>
                <p className="m-0 mt-2 text-sm text-slate-400">
                  Parents can register athletes for club tryouts, clinics, and camps.
                </p>
              </div>
              <div className="rounded-md border border-white/10 bg-black/20 p-4">
                <h2 className="m-0 text-lg text-white">Leagues</h2>
                <p className="m-0 mt-2 text-sm text-slate-400">
                  Players will use this portal for league registration.
                </p>
              </div>
              <div className="rounded-md border border-white/10 bg-black/20 p-4">
                <h2 className="m-0 text-lg text-white">Hatchlings</h2>
                <p className="m-0 mt-2 text-sm text-slate-400">
                  Youth league registration for younger Sidewinder players.
                </p>
              </div>
            </div>
          </section>
        </main>
        </>
      )}
    </>
  );
};

export default Home;
